<template>
  <navbar
    position="fixed"
    type="primary"
    :transparent="transparent"
    :color-on-scroll="colorOnScroll"
    menu-classes="ml-auto"
  >
    <template>
      <router-link v-popover:popover1 class="navbar-brand" to="/">
        <img :src="logomarca" class="logomarca" :v-if="mostrarLogo === true" />
      </router-link>
    </template>
    <template slot="navbar-menu">
      <drop-down tag="li" icon="fas fa-user" class="nav-item" v-if="this.status.loggedIn">
        <nav-link to="/perfil"> <i class="now-ui-icons users_circle-08"></i> Perfil </nav-link>
        <a class="dropdown-item" title="Logout" href="#" @click="logout">
          <font-awesome-icon icon="sign-out-alt" />
          <p>Logout</p>
        </a>
      </drop-down>
      <div class="btn-group" v-if="empresas != null && empresaAtual != null && empresas.length > 1">
        <b-dropdown id="dropdown-1" class="m-md-2 selectEmp" :text="empresaAtual.nomeFantasia">
          <b-dropdown-item
            v-for="emp in empresas"
            :key="emp.sigla"
            :active="emp.sigla === empresaAtual"
            @click="handleSelectEmpresa(emp)"
          >
            {{ emp.nomeFantasia }}
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </template>
  </navbar>
</template>

<script>
import { DropDown, Navbar, NavLink } from '@/components';
import { Popover } from 'element-ui';
import { mapState } from 'vuex';
export default {
  name: 'main-navbar',
  props: {
    transparent: Boolean,
    colorOnScroll: Number,
    mostrarLogo: Boolean
  },
  components: {
    DropDown,
    Navbar,
    NavLink,
    [Popover.name]: Popover
  },
  computed: {
    ...mapState('account', ['status']),
    ...mapState('empresa', ['empresas', 'empresaAtual']),
    ...mapState('logomarca', ['logomarcas', 'logomarcaAtual'])
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      logomarca: undefined
    };
  },
  methods: {
    handleSelectEmpresa(empresa) {
      if (empresa.sigla != this.empresaAtual.sigla) {
        this.$store.dispatch('empresa/select', empresa).then(() => {
          this.getLogomarca();
          this.$router.go();
          this.$router.push('/');
        });
      }
    },
    logout() {
      this.logomarca = undefined;
      this.$store.dispatch('account/logout').then(() => {
        this.$router.push('login');
      });
    },
    getLogomarca() {
      this.logomarca = undefined;
      if (this.empresaAtual != undefined) {
        if (this.logomarcas != null) {
          for (var item of this.logomarcas) {
            if (item.empresa === this.empresaAtual.sigla) {
              this.logomarca = 'data:image/png;base64,' + item.imagem;
              break;
            }
          }
        }

        if (this.logomarca == undefined) this.logomarca = process.env.VUE_APP_CONTEXT + 'img/oti-slim.png';
      }
    }
  },
  mounted() {
    this.getLogomarca();
  }
};
</script>
<style>
.logomarca {
  max-width: 100px;
  height: auto;
}

 .selectEmp .dropdown-menu {
    max-height: 200px;
    overflow-y: auto;
  }
</style>
